export const Role = {
	Admin: "Admin",
	Finance: "Finance",
	Reporting: "Reporting",
	Operations: "Operations",
	Vendor: "Vendor",
} as const;

export type RoleName = (typeof Role)[keyof typeof Role];
